import api from './main'

export const contactApi = {
  // 获取公开的办事处
  getPublicOffices(language = 'zh-CN') {
    return api.get('/system/office/public', {
      params: {
        language
      }
    })
  },
  getPublicFooterContacts(language = 'zh-CN') {
    return api.get('/system/footer-address/public', {
      params: {
        language
      }
    })
}
}

export default contactApi